<div class="reset-password-container">
    <div class="reset-password-card">
        <div *ngIf="!isSuccess" class="reset-password-header">
            <h1>Réinitialiser le Mot de Passe</h1>
            <p>Créez un nouveau mot de passe pour votre compte</p>
        </div>

        <!-- Token Validation States -->
        <div *ngIf="!isTokenChecked" class="loading-state">
            <div class="spinner"></div>
            <p>Validation du lien de réinitialisation...</p>
        </div>

        <div *ngIf="isTokenChecked && !isTokenValid" class="error-state">
            <h2>Lien Invalide</h2>
            <p>{{ errorMessage }}</p>
            <div class="action-buttons">
                <button class="btn-primary" (click)="router.navigate(['/forgot-password'])">
                    Demander un nouveau lien
                </button>
                <button class="btn-secondary" (click)="router.navigate(['/login'])">
                    Retour à la connexion
                </button>
            </div>
        </div>

        <!-- Reset Password Form -->
        <form *ngIf="isTokenChecked && isTokenValid && !isSuccess" class="reset-password-form" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
            <!-- New Password -->
            <div class="form-group">
                <label for="newPassword">Nouveau mot de passe *</label>
                <div class="input-group">
                    <input [type]="showPassword ? 'text' : 'password'" id="newPassword" formControlName="newPassword" [class.error]="hasError('newPassword')" placeholder="Entrez votre nouveau mot de passe" autocomplete="new-password">
                    <button type="button" class="password-toggle" (click)="togglePassword('password')">
                        <img src="assets/images/icons/eye.png" alt="eye-icon">
                    </button>
                </div>
                <div *ngIf="hasError('newPassword')" class="error-message">
                    {{ getFieldError('newPassword') }}
                </div>
                <div class="password-hint">
                    Le mot de passe doit contenir au moins 6 caractères.
                </div>
            </div>

            <!-- Confirm Password -->
            <div class="form-group">
                <label for="confirmPassword">Confirmer le mot de passe *</label>
                <div class="input-group">
                    <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" formControlName="confirmPassword" [class.error]="hasError('confirmPassword')" placeholder="Confirmez votre nouveau mot de passe" autocomplete="new-password">
                    <button type="button" class="password-toggle" (click)="togglePassword('confirmPassword')">
                        <img src="assets/images/icons/eye.png" alt="eye-icon">
                    </button>
                </div>
                <div *ngIf="hasError('confirmPassword')" class="error-message">
                    {{ getFieldError('confirmPassword') }}
                </div>
            </div>

            <!-- Error Message -->
            <div *ngIf="errorMessage" class="alert alert-error">
                {{ errorMessage }}
            </div>

            <!-- Submit Button -->
            <button type="submit" class="submit-btn" [disabled]="isLoading || resetPasswordForm.invalid" [class.loading]="isLoading">
                <span *ngIf="!isLoading">Réinitialiser le mot de passe</span>
                <span *ngIf="isLoading">Réinitialisation...</span>
            </button>
        </form>

        <!-- Success State -->
        <div *ngIf="isSuccess" class="success-state">
            <h2>Mot de Passe Réinitialisé!</h2>
            <p>{{ successMessage }}</p>
            <div class="action-buttons">
                <button class="btn-primary" (click)="router.navigate(['/login'])">
                    Se connecter maintenant
                </button>
            </div>
        </div>
    </div>
</div>